//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Formboard.js";
import "../no/Builder.js";
import "../Formboard/Formboard.LayoutLengthOptions.js";
import "../Routing/Routing.SelectControlPoint.js";
import "../no/Expression.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
let d=[[[0,"BranchAngleMethod",1,0],[0,"BranchShapeType",1,0],[1,"LengthOptions",0,"Formboard.LayoutLengthOptions",0],[1,"MainRunEndSelection",0,"Routing.SelectControlPoint",0],[0,"MainRunMethod",1,0],[0,"MainRunOrigin",1,"Point",0],[1,"MainRunStartSelection",0,"Routing.SelectControlPoint",0],[1,"MaximumRandomAngle",0,"Expression",0],[1,"MinimumRandomAngle",0,"Expression",0],[1,"PrimaryStandardAngle",0,"Expression",0],[0,"ReverseMainRun",1,0],[1,"SecondaryStandardAngle",0,"Expression",0],[1,"TertiaryStandardAngle",0,"Expression",0]],[[[],"CreateDefaultGeometry",{},0,0],[[],"UpdateLayout",{},0,0],[[],"TranslateToNewOrigin",{},0,0]],[]];
SPLM.Formboard.FormboardLayoutBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Formboard.FormboardLayoutBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Formboard.FormboardLayoutBuilder.MainRunType = Object.freeze({
    "Longest" : "Longest", "Thickest" : "Thickest", "UserSelection" : "UserSelection"});

SPLM.Formboard.FormboardLayoutBuilder.BranchAngle = Object.freeze({
    "AsDesigned" : "AsDesigned", "StandardAngles" : "StandardAngles", "MaximumAngles" : "MaximumAngles", "RandomAngles" : "RandomAngles"});

SPLM.Formboard.FormboardLayoutBuilder.BranchShape = Object.freeze({
    "Straight" : "Straight", "Angled" : "Angled"});

export default SPLM;